import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { filter } from 'rxjs/operators';
import { CreateAlertModal } from '../../../modals/app-security-modals/create-alert-modal/create-alert-modal.component';

@Component({
  selector: 'app-alert-management',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
})
export class AlertManagementComponent implements OnInit {
  constructor(
    private location: Location,
    private router: Router,
    private modalService: SuiModalService
  ) {}

  goBack() {
    this.router.navigate(['/admin/setting/application-security']);
  }

  urlLastSegment: string;

  onCreateLogAlertModal() {
    this.modalService
      .open(new CreateAlertModal('Create Alert', {}))
      .onApprove(() => {
        location.reload();
      })
      .onDeny(() => {});
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.urlLastSegment = event.urlAfterRedirects.split('/').pop();
      });
  }
}
